import {
  Box,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverProps,
  PopoverTrigger,
  Portal,
  useDisclosure,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiBell } from "react-icons/fi";
import { useListMyNotificationsQuery } from "../../../autogen/bff-api";
import { NotificationDropdown } from "./NotificationDropdown";

// `placement` is configurable so the bell can sit on the right of the mobile top bar (bottom-end)
// or next to the logo in the left sidebar (bottom-start), where bottom-end would open off-screen.
export const NotificationBell = ({ placement = "bottom-end" }: { placement?: PopoverProps["placement"] }) => {
  const { t } = useTranslation();
  const { isOpen, onToggle, onClose } = useDisclosure();
  // Unread, not unseen: opening the dropdown or the alert list marks everything peeked, which used
  // to empty this badge for good while the alerts themselves sat unopened. The badge is meant to say
  // "there is something to deal with", so it counts what has not been opened.
  const { data } = useListMyNotificationsQuery({ unread: true });
  const count = data?.notifications.length ?? 0;

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement={placement} isLazy>
      <PopoverTrigger>
        <Box position="relative" display="inline-flex">
          <IconButton aria-label={t("Alerts")} icon={<FiBell />} variant="ghost" size="md" onClick={onToggle} />
          {count > 0 && (
            <Box position="absolute" top="0" right="0" minW="18px" h="18px" px="1" rounded="full" bg="smError" color="white" fontSize="2xs" fontWeight="bold" display="flex" alignItems="center" justifyContent="center" border="2px solid" borderColor="smBackground">
              {count > 9 ? "9+" : count}
            </Box>
          )}
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent w="auto" bg="smBackground" borderColor="smBorder" shadow="xl" _focus={{ outline: "none" }}>
          <PopoverBody p="0">
            <NotificationDropdown onClose={onClose} />
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
